import React, { useState, useEffect, useRef } from 'react';
import '../CSS/Global.css';
import logo from '../Img/LOGO  - FINAL - 01.png';
import { useNavigate, useLocation } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { Link } from 'react-router-dom';


const Header = () => {
    const navigate = useNavigate();
    const [searchQuery, setSearchQuery] = useState('');
    const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
    const [drawerOpen, setDrawerOpen] = useState(false);
    const [openDropdown, setOpenDropdown] = useState(null);
    const location = useLocation();
    const currentPath = location.pathname;
    const [showSearch, setShowSearch] = useState(false);
    const searchRef = useRef(null);
    const [isLoggedIn, setIsLoggedIn] = useState(false);
    const [totalRegistrations, setTotalRegistrations] = useState(0);
    const [totalViews, setTotalViews] = useState(0);



    const login = JSON.parse(localStorage.getItem("isLoggedIn"));


    function formatNumberIndianStyle(num) {
        if (num >= 1e7) {
            return (num / 1e7).toFixed(1).replace(/\.0$/, '') + 'Cr';
        } else if (num >= 1e5) {
            return (num / 1e5).toFixed(1).replace(/\.0$/, '') + 'L';
        } else if (num >= 1e3) {
            return (num / 1e3).toFixed(1).replace(/\.0$/, '') + 'K';
        } else {
            return num.toString();
        }
    }


    const handleSearchClick = (e) => {
        e.stopPropagation();
        setShowSearch(!showSearch);
    };

    const handleSearchChange = (e) => {
        setSearchQuery(e.target.value);
    };

    const handleKeyDown = (e) => {
        if (e.key === 'Enter') {
            navigate(`/search-impact?query=${encodeURIComponent(searchQuery)}`);
            setShowSearch(false);
        }
    };

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (searchRef.current && !searchRef.current.contains(event.target)) {
                setShowSearch(false);
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);

    const handleResize = () => {
        setIsMobile(window.innerWidth < 768);
        if (window.innerWidth >= 768) setDrawerOpen(false);
    };

    useEffect(() => {
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    const toggleDropdown = (key) => {
        setOpenDropdown(openDropdown === key ? null : key);
    };

    const handleNavigate = (path) => {
        const login = JSON.parse(localStorage.getItem("isLoggedIn"));

        // If trying to access "submit your article" without login
        if (path === "/submit-your-article-impact" && !login) {
            toast.error("Please log in to submit your article.");
            navigate("/login-impact");
            return;
        }

        if (path === "/processing-fees-form" && !login) {
            toast.error("Please log in to process your fees.");
            navigate("/login-impact");
            return;
        }

        navigate(path);
        setDrawerOpen(false);
    };


    useEffect(() => {
        const checkLoginStatus = () => {
            const loginStatus = localStorage.getItem("isLoggedIn");
            setIsLoggedIn(loginStatus === "true");
        };

        checkLoginStatus();

        window.addEventListener("storage", checkLoginStatus);
        return () => window.removeEventListener("storage", checkLoginStatus);
    }, []);

    useEffect(() => {
        const fetchTotalRegistrations = async () => {
            try {
                const response = await fetch("https://backend.impactjournal.co.in/register/total-registrations");
                if (!response.ok) throw new Error('Failed to fetch total registrations');
                const data = await response.json();
                setTotalRegistrations(data.total);
            } catch (error) {
                console.error('Error fetching registration count:', error);
            }
        };

        fetchTotalRegistrations();
    }, []);

    useEffect(() => {
        const fetchTotalViews = async () => {
            try {
                const response = await fetch("https://backend.impactjournal.co.in/register/totalsite-views");
                if (!response.ok) throw new Error('Failed to fetch site views');
                const data = await response.json();
                setTotalViews(data.totalViews);
            } catch (error) {
                console.error('Error fetching total views:', error);
            }
        };

        fetchTotalViews();
    }, []);

    useEffect(() => {
        if (!sessionStorage.getItem("siteViewTracked")) {
            fetch("https://backend.impactjournal.co.in/register/site-view")
                .then(res => res.json())
                .then(data => {
                    console.log("Site view tracked", data.totalViews);
                    setTotalViews(data.totalViews);
                    sessionStorage.setItem("siteViewTracked", "true");
                })
                .catch(err => console.error("Tracking error", err));
        }
    }, []);







    return (
        <header>
            {/* <ToastContainer position="top-center" autoClose={3000} /> */}
            <div className="header-top-container-pm">
                <div className="header-top-wrapper-pm">
                    <div className="header-top-left-pm">
                        <img
                            src={logo}
                            alt="Journal Logo"
                            className="header-top-logo-pm animate__animated animate__slideInDown"
                            onClick={() => window.location.href = '/'}
                            style={{ cursor: 'pointer' }}
                        />
                        <div className="impact-header-updated">
                            <div className="header-top-bar-impact">
                                <div className="header-top-bar-left-impact">
                                    <h1 className="header-top-title-pm">
                                        <span className='logo-name-first-letter'>I</span>nternational <span className='logo-name-first-letter'>M</span>ultidisciplinary <span className='logo-name-first-letter'>P</span>harmaceutical <span className='logo-name-first-letter'>A</span>nd <span className='logo-name-first-letter'>C</span>linical <span className='logo-name-first-letter'>T</span>rends
                                    </h1>
                                </div>
                                <div className="header-top-bar-right">
                                    <div className="header-top-bar-register-and-login">
                                        <p className='header-top-registration-number'>
                                            Total Registration ( {totalRegistrations} )
                                        </p>

                                        <p className='header-top-registration-number'>
                                            Total Views ( {totalViews} )
                                        </p>


                                        {login && (
                                            <p className='header-top-bar-register-impact'>
                                                <Link to="/my-account" style={{ color: 'inherit', textDecoration: 'none' }}>
                                                    <i className="fa-solid fa-circle-user"></i> My Account
                                                </Link>
                                            </p>
                                        )}

                                        {!login && (
                                            <p className='header-top-bar-register-impact' onClick={() => navigate('/login-impact')} style={{ cursor: 'pointer' }}>
                                                <i className="fa-solid fa-arrow-right-to-bracket"></i> Login
                                            </p>
                                        )}
                                        {login && (
                                            <p
                                                className='header-top-bar-register-impact'
                                                onClick={() => {
                                                    localStorage.removeItem("isLoggedIn");
                                                    window.dispatchEvent(new Event("storage")); // updates all listeners
                                                    setIsLoggedIn(false);
                                                    navigate("/");
                                                }}

                                                style={{ cursor: 'pointer' }}
                                            >
                                                <i className="fa-solid fa-arrow-right-from-bracket"></i> Logout
                                            </p>
                                        )}

                                    </div>
                                </div>
                            </div>
                            <div className="header-top-textblock-pm">
                                <p className="header-top-subtitle-pm">
                                    Publishing Model
                                </p>
                                <p className="header-top-description-pm">
                                    Open access
                                </p>
                                <div className="header-additional-info-pm">
                                    <div className="header-additional-card-pm">
                                        <h3>2 Days</h3>
                                        <p>Time to first decision</p>
                                    </div>
                                    <div className="header-additional-card-pm">
                                        <h3>5 Days</h3>
                                        <p>Review time</p>
                                    </div>
                                    <div className="header-additional-card-pm">
                                        <h3>12 Days</h3>
                                        <p>Submission to acceptance</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Right section with stats and ISO badge */}
                    {/* <div className="header-top-right-pm">
                        <p className="header-top-info-pm">ISSN 2394-3211</p>
                        <p className="header-top-info-pm">IMPACT FACTOR: 7.065</p>
                        <p className="header-top-info-pm">ICV - 79.57</p>
                        <p
                            className="header-top-login-pm"
                            onClick={() => navigate('/register-impact')}
                            style={{ cursor: 'pointer' }}
                        >
                            Login | Register
                        </p>
                        <img
                            src={isoBadge}
                            alt="ISO Badge"
                            className="header-top-iso-pm animate__animated animate__slideInUp"
                        />
                    </div> */}
                </div>
            </div>
            <nav className="main-header-container-pm">
                {isMobile ? (
                    <>
                        <div className="header-top-bar-impact">
                            <div className="header-top-bar-left-impact">
                                <h1 className="header-top-title-pm">
                                    <span className='logo-name-first-letter'>I</span>nternational <span className='logo-name-first-letter'>M</span>ultidisciplinary <span className='logo-name-first-letter'>P</span>harmaceutical <span className='logo-name-first-letter'>A</span>nd <span className='logo-name-first-letter'>C</span>linical <span className='logo-name-first-letter'>T</span>rends
                                </h1>
                            </div>
                            <div className="header-top-bar-right">
                                <div className="header-top-bar-register-and-login">
                                    <p className='header-top-registration-number'>
                                        Total Registration ( {totalRegistrations} )
                                    </p>

                                    <p className='header-top-registration-number'>
                                        Total Views ( {totalViews} )
                                    </p>

                                    {/* <p className='header-top-bar-register-impact'>
                                        <Link to="/my-account" style={{ color: 'inherit', textDecoration: 'none' }}>
                                            <i className="fa-solid fa-circle-user"></i> My Account
                                        </Link>
                                    </p>
                                    <p className='header-top-bar-register-impact' onClick={() => navigate('/login-impact')}
                                        style={{ cursor: 'pointer' }}>
                                        <i className="fa-solid fa-arrow-right-to-bracket"></i> Login
                                    </p> */}
                                </div>
                            </div>
                        </div>
                        <div className="mobile-headers-strip-impact">
                            <div className="mobile-logo-impact">
                                <img
                                    src={logo}
                                    alt="Journal Logo"
                                    className="header-top-logo-pm animate__animated animate__slideInDown"
                                    onClick={() => window.location.href = '/'}
                                    style={{ cursor: 'pointer' }}
                                />
                            </div>
                            <div className="mobile-header-icons-impact">
                                <li className="search-container" ref={searchRef}>
                                    <span
                                        className="main-header-link-pm"
                                        onClick={handleSearchClick}
                                    >
                                        <i className="fa-solid fa-magnifying-glass"></i>
                                    </span>
                                    {showSearch && (
                                        <input
                                            type="text"
                                            placeholder="Search journal insight"
                                            className="search-input"
                                            value={searchQuery}
                                            onChange={handleSearchChange}
                                            onKeyDown={handleKeyDown}
                                        />
                                    )}
                                </li>
                                {login && (
                                    <i class="fa-solid fa-circle-user" style="cursor: pointer;" onclick="window.location.href='/my-account';"></i>
                                )}
                                <div className="hamburger-icon" onClick={() => setDrawerOpen(!drawerOpen)}>
                                    <i className="fas fa-bars"></i>
                                </div>
                            </div>
                        </div>
                        {drawerOpen && (
                            <>
                                <div className="drawer-backdrop" />
                                <div className={`mobile-drawer ${drawerOpen ? 'open' : ''}`}>
                                    <div className="drawer-close-icon" onClick={() => setDrawerOpen(false)}>
                                        <i className="fa-solid fa-xmark"></i>
                                    </div>

                                    <img
                                        src={logo}
                                        alt="Journal Logo"
                                        className="header-top-logo-pm"
                                        onClick={() => {
                                            setDrawerOpen(false);
                                            navigate('/');
                                        }}
                                        style={{ cursor: 'pointer' }}
                                    />

                                    <ul className="mobile-menu-list">
                                        <li><span onClick={() => { handleNavigate('/'); setDrawerOpen(false); }}>HOME</span></li>

                                        <li>
                                            <span onClick={() => { toggleDropdown('about') }}>
                                                ABOUT US <i className={`fas ${openDropdown === 'about' ? 'fa-minus' : 'fa-plus'}`}></i>
                                            </span>
                                            {openDropdown === 'about' && (
                                                <ul>
                                                    <li><span onClick={() => { handleNavigate('/aim-and-scope'); setDrawerOpen(false); }}>Aims & Scope</span></li>
                                                    <li><span onClick={() => { handleNavigate('/about-editorial-board-impact'); setDrawerOpen(false); }}>Editorial Team</span></li>
                                                    <li><span onClick={() => { handleNavigate('/journal-insight'); setDrawerOpen(false); }}>Journal Insights</span></li>
                                                    <li><span onClick={() => { handleNavigate('/news'); setDrawerOpen(false); }}>News</span></li>
                                                    <li><span onClick={() => { handleNavigate('/announcement'); setDrawerOpen(false); }}>Announcements</span></li>
                                                </ul>
                                            )}
                                        </li>

                                        <li>
                                            <span onClick={() => { toggleDropdown('publish') }}>
                                                PUBLISH <i className={`fas ${openDropdown === 'publish' ? 'fa-minus' : 'fa-plus'}`}></i>
                                            </span>
                                            {openDropdown === 'publish' && (
                                                <ul>
                                                    <li><span onClick={() => { handleNavigate('/submit-your-article-impact'); setDrawerOpen(false); }}>Submit Your Article</span></li>
                                                    <li><span onClick={() => { handleNavigate('/guide-for-author'); setDrawerOpen(false); }}>Guide For Author</span></li>
                                                    <li><span onClick={() => { handleNavigate('/fees-and-funding'); setDrawerOpen(false); }}>Fees & Funding</span></li>
                                                    <li><span onClick={() => { handleNavigate('/track-your-article'); setDrawerOpen(false); }}>Track Your Article</span></li>
                                                </ul>
                                            )}
                                        </li>

                                        <li>
                                            <span onClick={() => { toggleDropdown('journals') }}>
                                                JOURNALS <i className={`fas ${openDropdown === 'journals' ? 'fa-minus' : 'fa-plus'}`}></i>
                                            </span>
                                            {openDropdown === 'journals' && (
                                                <ul>
                                                    <li><span onClick={() => { handleNavigate('/pharmaceutical-science'); setDrawerOpen(false); }}>Pharmaceutical Sciences</span></li>
                                                    <li><span onClick={() => { handleNavigate('/medical-science'); setDrawerOpen(false); }}>Medical Sciences</span></li>
                                                    <li><span onClick={() => { handleNavigate('/biological-science'); setDrawerOpen(false); }}>Biological Sciences</span></li>
                                                </ul>
                                            )}
                                        </li>

                                        <li><span onClick={() => { handleNavigate('/current-issues'); setDrawerOpen(false); }}>CURRENT ISSUE</span></li>
                                        <li><span onClick={() => { handleNavigate('/processing-fees'); setDrawerOpen(false); }}>PROCESSING FEES</span></li>
                                        <li><span onClick={() => { handleNavigate('/about-editorial-board-impact'); setDrawerOpen(false); }}>EDITORIAL BOARD</span></li>
                                        <li><span onClick={() => { handleNavigate('/contact-us'); setDrawerOpen(false); }}>CONTACT US</span></li>

                                        <li>
                                            {!isLoggedIn && (
                                                <p
                                                    className='header-top-bar-register-impact'
                                                    onClick={() => { setDrawerOpen(false); navigate('/login-impact'); }}
                                                    style={{ cursor: 'pointer' }}
                                                >
                                                    <i className="fa-solid fa-arrow-right-to-bracket"></i> Login
                                                </p>
                                            )}
                                            {isLoggedIn && (
                                                <p
                                                    className='header-top-bar-register-impact'
                                                    onClick={() => {
                                                        localStorage.removeItem("isLoggedIn");
                                                        window.dispatchEvent(new Event("storage"));
                                                        setIsLoggedIn(false);
                                                        setDrawerOpen(false);
                                                        navigate('/');
                                                    }}
                                                    style={{ cursor: 'pointer' }}
                                                >
                                                    <i className="fa-solid fa-arrow-right-from-bracket"></i> Logout
                                                </p>
                                            )}
                                        </li>
                                    </ul>
                                </div>
                            </>
                        )}
                    </>
                ) : (
                    <ul className="main-header-menu-pm">
                        <li>
                            <span className={`main-header-link-pm ${currentPath === '/' ? 'active' : ''}`} onClick={() => handleNavigate('/')}>
                                HOME
                            </span>
                        </li>

                        {/* ABOUT US */}
                        <li
                            className="main-header-dropdown-pm"
                            onMouseEnter={() => setOpenDropdown('about')}
                            onMouseLeave={() => setOpenDropdown(null)}
                        >
                            <span
                                className={`main-header-link-pm ${openDropdown === 'about' ||
                                    currentPath.startsWith('/about') ||
                                    currentPath === '/about-editorial-board-impact'
                                    ? 'active'
                                    : ''
                                    }`}
                                onClick={() => toggleDropdown('about')}
                            >
                                ABOUT US <i className={`fas ${openDropdown === 'about' ? 'fa-minus' : 'fa-plus'} dropdown-icon`}></i>
                            </span>
                            {openDropdown === 'about' && (
                                <ul className="main-header-submenu-pm">
                                    <li>
                                        <span className={`main-header-sublink-pm ${currentPath === '/aim-and-scope' ? 'active' : ''}`} onClick={() => handleNavigate('/aim-and-scope')}>
                                            Aims & Scope
                                        </span>
                                    </li>
                                    {/* <li>
                                        <span className={`main-header-sublink-pm ${currentPath === '/about-editorial-board-impact' ? 'active' : ''}`} onClick={() => handleNavigate('/about-editorial-board-impact')}>
                                            Editorial Board
                                        </span>
                                    </li> */}
                                    <li>
                                        <span className={`main-header-sublink-pm ${currentPath === '/journal-insight' ? 'active' : ''}`} onClick={() => handleNavigate('/journal-insight')}>
                                            Journal Insights
                                        </span>
                                    </li>
                                    <li>
                                        <span className={`main-header-sublink-pm ${currentPath === '/news' ? 'active' : ''}`} onClick={() => handleNavigate('/news')}>
                                            News
                                        </span>
                                    </li>
                                    <li>
                                        <span className={`main-header-sublink-pm ${currentPath === '/announcement' ? 'active' : ''}`} onClick={() => handleNavigate('/announcement')}>
                                            Announcements
                                        </span>
                                    </li>
                                </ul>
                            )}
                        </li>

                        {/* PUBLISH */}
                        <li
                            className="main-header-dropdown-pm"
                            onMouseEnter={() => setOpenDropdown('publish')}
                            onMouseLeave={() => setOpenDropdown(null)}
                        >
                            <span
                                className={`main-header-link-pm ${openDropdown === 'publish' || currentPath.startsWith('/publish') ? 'active' : ''
                                    }`}
                                onClick={() => toggleDropdown('publish')}
                            >
                                Publish <i className={`fas ${openDropdown === 'publish' ? 'fa-minus' : 'fa-plus'} dropdown-icon`}></i>
                            </span>
                            {openDropdown === 'publish' && (
                                <ul className="main-header-submenu-pm">
                                    <li>
                                        <span className={`main-header-sublink-pm ${currentPath === '/submit-your-article-impact' ? 'active' : ''}`} onClick={() => handleNavigate('/submit-your-article-impact')}>
                                            Submit your article
                                        </span>
                                    </li>
                                    <li>
                                        <span className={`main-header-sublink-pm ${currentPath === '/guide-for-author' ? 'active' : ''}`} onClick={() => handleNavigate('/guide-for-author')}>
                                            Guide for author
                                        </span>
                                    </li>
                                    <li>
                                        <span className={`main-header-sublink-pm ${currentPath === '/fees-and-funding' ? 'active' : ''}`} onClick={() => handleNavigate('/fees-and-funding')}>
                                            Fees & funding
                                        </span>
                                    </li>
                                    <li>
                                        <span className={`main-header-sublink-pm ${currentPath === '/track-your-article' ? 'active' : ''}`} onClick={() => handleNavigate('/track-your-article')}>
                                            Track Your Article
                                        </span>
                                    </li>
                                </ul>
                            )}
                        </li>

                        {/* JOURNALS */}
                        <li
                            className="main-header-dropdown-pm"
                            onMouseEnter={() => setOpenDropdown('journals')}
                            onMouseLeave={() => setOpenDropdown(null)}
                        >
                            <span
                                className={`main-header-link-pm ${openDropdown === 'journals' || currentPath.startsWith('/journals') ? 'active' : ''
                                    }`}
                                onClick={() => toggleDropdown('journals')}
                            >
                                JOURNALS <i className={`fas ${openDropdown === 'journals' ? 'fa-minus' : 'fa-plus'} dropdown-icon`}></i>
                            </span>
                            {openDropdown === 'journals' && (
                                <ul className="main-header-submenu-pm">
                                    <li>
                                        <span className={`main-header-sublink-pm ${currentPath === '/pharmaceutical-science' ? 'active' : ''}`} onClick={() => handleNavigate('/pharmaceutical-science')}>
                                            Pharmaceutical Sciences
                                        </span>
                                    </li>
                                    <li>
                                        <span className={`main-header-sublink-pm ${currentPath === '/medical-science' ? 'active' : ''}`} onClick={() => handleNavigate('/medical-science')}>
                                            Medical Sciences
                                        </span>
                                    </li>
                                    <li>
                                        <span className={`main-header-sublink-pm ${currentPath === '/biological-science' ? 'active' : ''}`} onClick={() => handleNavigate('/biological-science')}>
                                            Biological Sciences
                                        </span>
                                    </li>
                                </ul>
                            )}
                        </li>

                        <li
                            className="main-header-dropdown-pm"
                            onMouseEnter={() => setOpenDropdown('general-issue')}
                            onMouseLeave={() => setOpenDropdown(null)}
                        >
                            <span
                                className={`main-header-link-pm ${openDropdown === 'general-issue' || currentPath.startsWith('/general-issue') ? 'active' : ''
                                    }`}
                                onClick={() => toggleDropdown('general-issue')}
                            >
                                ISSUES <i className={`fas ${openDropdown === 'general-issue' ? 'fa-minus' : 'fa-plus'} dropdown-icon`}></i>
                            </span>
                            {openDropdown === 'general-issue' && (
                                <ul className="main-header-submenu-pm">
                                    <li>
                                        <span className={`main-header-sublink-pm ${currentPath === '/current-issues' ? 'active' : ''}`} onClick={() => handleNavigate('/current-issues')}>
                                            Current Issue
                                        </span>
                                    </li>
                                    <li>
                                        <span className={`main-header-sublink-pm ${currentPath === '/archive' ? 'active' : ''}`} onClick={() => handleNavigate('/archive')}>
                                            Archieve
                                        </span>
                                    </li>

                                </ul>
                            )}
                        </li>
                        <li
                            className="main-header-dropdown-pm"
                            onMouseEnter={() => setOpenDropdown('E-content')}
                            onMouseLeave={() => setOpenDropdown(null)}
                        >
                            <span
                                className={`main-header-link-pm ${openDropdown === 'E-content' || currentPath.startsWith('/E-content') ? 'active' : ''
                                    }`}
                                onClick={() => toggleDropdown('E-content')}
                            >
                                E-CONTENT <i className={`fas ${openDropdown === 'E-content' ? 'fa-minus' : 'fa-plus'} dropdown-icon`}></i>
                            </span>
                            {openDropdown === 'E-content' && (
                                <ul className="main-header-submenu-pm">
                                    <li>
                                        <span className={`main-header-sublink-pm ${currentPath === '/e-library' ? 'active' : ''}`} onClick={() => handleNavigate('/e-library')}>
                                            E-Library
                                        </span>
                                    </li>
                                   <li>
                                        <span className={`main-header-sublink-pm ${currentPath === '/e-journal' ? 'active' : ''}`} onClick={() => handleNavigate('/e-journal')}>
                                            E-Journal
                                        </span>
                                    </li>
                                    <li>
                                        <span className={`main-header-sublink-pm ${currentPath === '/e-magazine' ? 'active' : ''}`} onClick={() => handleNavigate('/e-magazine')}>
                                            E-Magazine
                                        </span>
                                    </li>
                                    <li>
                                        <span className={`main-header-sublink-pm ${currentPath === '/e-hbr' ? 'active' : ''}`} onClick={() => handleNavigate('/e-hbr')}>
                                            E-HBI
                                        </span>
                                    </li>

                                </ul>
                            )}
                        </li>
                        {/* <li>
                            <span className={`main-header-link-pm ${currentPath === '/current-issues' ? 'active' : ''}`} onClick={() => handleNavigate('/current-issues')}>
                                CURRENT ISSUE
                            </span>
                        </li> */}

                        <li>
                            <span className={`main-header-link-pm ${currentPath === '/processing-fees' ? 'active' : ''}`} onClick={() => handleNavigate('/processing-fees')}>
                                PROCESSING FEES
                            </span>
                        </li>

                        <li>
                            <span className={`main-header-link-pm ${currentPath === '/about-editorial-board-impact' ? 'active' : ''}`} onClick={() => handleNavigate('/about-editorial-board-impact')}>
                                EDITORIAL BOARD
                            </span>
                        </li>

                        <li>
                            <span className={`main-header-link-pm ${currentPath === '/contact-us' ? 'active' : ''}`} onClick={() => handleNavigate('/contact-us')}>
                                CONTACT US
                            </span>
                        </li>

                        <li className="search-container" ref={searchRef}>
                            <span
                                className={`main-header-link-pm ${currentPath === '/search' ? 'active' : ''}`}
                                onClick={handleSearchClick}
                            >
                                <i className="fa-solid fa-magnifying-glass"></i> SEARCH INSIGHT JOURNAL
                            </span>
                            {showSearch && (
                                <input
                                    type="text"
                                    placeholder="Search insight journal"
                                    className="search-input"
                                    value={searchQuery}
                                    onChange={handleSearchChange}
                                    onKeyDown={handleKeyDown}
                                />
                            )}
                        </li>
                    </ul>
                )
                }
            </nav >
            <div className="mobile-information-impact">
                <div className="header-top-textblock-pm">
                    <p className="header-top-subtitle-pm">
                        Publishing Model
                    </p>
                    <p className="header-top-description-pm">
                        Open access
                    </p>
                    <div className="header-additional-info-pm">
                        <div className="header-additional-card-pm">
                            <h3>2 Days</h3>
                            <p>Time to first decision</p>
                        </div>
                        <div className="header-additional-card-pm">
                            <h3>5 Days</h3>
                            <p>Review time</p>
                        </div>
                        <div className="header-additional-card-pm">
                            <h3>12 Days</h3>
                            <p>Submission to acceptance</p>
                        </div>
                    </div>
                </div>
            </div>
        </header >
    );
};

export default Header;
